module.exports = __webpack_public_path__ + "img/kununu-en.c5582f43.png";